import { RefObject, useLayoutEffect } from 'react'

export const useResize = (
  containerRef: RefObject<HTMLDivElement | null>,
  canvasRef: RefObject<HTMLDivElement | null>,
  aspectRatio: number = 16 / 9
) => {
  useLayoutEffect(() => {
    const wrapperElement = containerRef.current
    const innerElement = canvasRef.current

    if (!wrapperElement || !innerElement) return

    const resizeObserver = new ResizeObserver(entries => {
      const entry = entries[0]
      const { width, height } = entry.contentRect

      const widthBasedHeight = width / aspectRatio
      const finalHeight = Math.min(height, widthBasedHeight)
      const finalWidth = finalHeight * aspectRatio

      innerElement.style.width = `${finalWidth}px`
      innerElement.style.height = `${finalHeight}px`
    })

    resizeObserver.observe(wrapperElement)

    return () => {
      resizeObserver.disconnect()
    }
  }, [containerRef, canvasRef, aspectRatio])
}
